import { t } from "ttag";

import { LoadingAndErrorWrapper } from "metabase/common/components/LoadingAndErrorWrapper";
import { useAdminSetting } from "metabase/settings";
import type { EnterpriseSettings } from "metabase-types/api";

import { AuthCard } from "../../components/AuthCard";
import { LDAP_SCHEMA } from "../../constants";

export function LdapAuthCard() {
  const {
    value: isLdapConfigured,
    updateSetting,
    updateSettings,
    settingDetails,
    isLoading,
  } = useAdminSetting("ldap-configured?");
  const { value: isEnabled } = useAdminSetting("ldap-enabled");

  const handleDeactivate = () => {
    return updateSettings(
      // Unjustified type cast. FIXME
      LDAP_SCHEMA.getDefault() as Partial<EnterpriseSettings>,
    );
  };

  if (isLoading) {
    return <LoadingAndErrorWrapper loading />;
  }

  return (
    <AuthCard
      type="ldap"
      name={t`LDAP`}
      description={t`Allows users within your LDAP directory to log in to Metabase with their LDAP credentials, and allows automatic mapping of LDAP groups to Metabase groups.`}
      isEnabled={!!isEnabled}
      onChange={(newValue) =>
        updateSetting({
          key: "ldap-enabled",
          value: newValue,
        })
      }
      isConfigured={!!isLdapConfigured}
      onDeactivate={handleDeactivate}
      setting={settingDetails}
    />
  );
}
